import { Injectable } from '@angular/core';
import {ErrorTemplate} from '../../models/ErrorTemplate';
import {Subject} from 'rxjs/Subject';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ValidationHandlerService {

  private _validationErrorsSubject: Subject<ErrorTemplate[]> = new Subject<ErrorTemplate[]>();
  private _validationDisplaySubject: Subject<boolean> = new BehaviorSubject<boolean>(true);

  get validationErrorsSubject(): Observable<ErrorTemplate[]> {
    return this._validationErrorsSubject.asObservable();
  }

  updateErrors(errors: ErrorTemplate[]) {
    this._validationErrorsSubject.next(errors);
  }

  get validationDisplaySubject(): Observable<boolean> {
    return this._validationDisplaySubject.asObservable();
  }

  shouldDisplayErrors(display: boolean) {
    this._validationDisplaySubject.next(display);
  }

  resetErrors() {
    this._validationErrorsSubject.next([]);
    this._validationDisplaySubject.next(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/validation-handler.service.ts